import { useEffect, useState } from "react";

const BUILD_TIMEOUT_S = 15 * 60;

export const fmtClock = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

// Ticks once a second and derives elapsed / remaining / retry countdowns from the creation's build timestamps.
export const useBuildClock = (creation) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const start = creation.build_started_at ? new Date(creation.build_started_at).getTime() : now;
  const elapsed = Math.max(0, Math.floor((now - start) / 1000));
  const deadline = creation.build_deadline_at ? new Date(creation.build_deadline_at).getTime() : start + BUILD_TIMEOUT_S * 1000;
  const remaining = Math.max(0, Math.floor((deadline - now) / 1000));
  const windowS = Math.max(60, Math.round((deadline - start) / 1000));
  const retryIn = creation.next_retry_at ? Math.max(0, Math.ceil((new Date(creation.next_retry_at).getTime() - now) / 1000)) : 0;
  return { elapsed, remaining, progress: elapsed / windowS, retryIn };
};
